module.exports = __webpack_public_path__ + "img/first-zh-m.701a5962.png";